import React from "react";
import { IonText } from "@ionic/react";

const locale = "en-AU"; // TODO - add locale to config
const options = {
  hour: "numeric",
  minute: "numeric",
  timeZone: "Australia/Sydney",
};
function formatISOTime(tString) {
  const formattedTime = new Intl.DateTimeFormat(locale, options).format(
    Date.parse(tString)
  );
  return formattedTime;
}

const TimeShort = ({ time = new Date().toISOString() }) => {
  return <IonText>{formatISOTime(time)}</IonText>;
};

export default TimeShort;
